import { render } from "./FileUploadModal.vue?vue&type=template&id=edffa1f4&scoped=true"
import script from "./FileUploadModal.vue?vue&type=script&lang=js"
export * from "./FileUploadModal.vue?vue&type=script&lang=js"

import "./FileUploadModal.vue?vue&type=style&index=0&id=edffa1f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edffa1f4"]])

export default __exports__